import { render, staticRenderFns } from "./BlockFeaturedVideoSectionAwardsItem.vue?vue&type=template&id=5c25965b&scoped=true&"
import script from "./BlockFeaturedVideoSectionAwardsItem.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedVideoSectionAwardsItem.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedVideoSectionAwardsItem.vue?vue&type=style&index=0&id=5c25965b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25965b",
  null
  
)

export default component.exports